module.exports = __webpack_public_path__ + "img/xmsb1.9dbcd003.png";